mutation ClearSentenceWhitespace($barMitzvah: String!, $sentence: ID!, $overlay: ID) {
  clearSentenceWhitespace(barMitzvah: $barMitzvah, sentence: $sentence, overlay: $overlay) {
    ok
    errors
  }
}
